import { SourceGrid } from '@/features/SourceGrid';
import { useDocumentTitle, useResetQueryState } from '@/hooks';

export default function SourcesPage() {
    useDocumentTitle('sources');
    useResetQueryState();

    return <SourceGrid />;
}
